import React from 'react';
import EmailForm from '../components/email/EmailForm';
import { Paper } from '@material-ui/core';


const EmailView = ({match}) => {

  return (
    <>
      <Paper elevation={2}>
        <EmailForm match={match} />
      </Paper>


    </>
  );
};


export default EmailView;
